import { render } from "./eyerweb-patient-list.vue?vue&type=template&id=dd3f6e12&scoped=true"
import script from "./eyerweb-patient-list.vue?vue&type=script&lang=js"
export * from "./eyerweb-patient-list.vue?vue&type=script&lang=js"

import "./eyerweb-patient-list.vue?vue&type=style&index=0&id=dd3f6e12&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd3f6e12"]])

export default __exports__